import { graphql, useStaticQuery } from 'gatsby'
import { ImageItem } from '@kentico/gatsby-kontent-components/dist/image-element'
import { filterSectionsByLanguage } from '../../common/serviceHelpers'
import { KenticoEmployeeElement } from '../Person/model'
import _get from 'lodash/get'

/* Kentico model: Contact Section */
export interface KenticoContactSection extends KontentItem {
  header: KontentTextElement
  contact_person: KenticoEmployeeElement
  linkedin_url: KontentTextElement
  calendly_text: KontentTextElement
  calendly_url: KontentTextElement
  region: KontentTextElement
}

export class ContactSection {
  header: string
  name: string
  phone: string
  email: string
  photo: ImageItem
  videoUrl: string
  position: string
  linkedIn: string
  calendlyText: string
  calendlyUrl: string
  regionCodes: string

  constructor(data: KenticoContactSection) {
    this.header = _get(data, 'section_header.value', '')
    this.name = _get(data, 'contact_person.value[0].elements.name.value', '')
    this.phone = _get(data, 'contact_person.value[0].elements.mobile.value', '')
    this.email = _get(data, 'contact_person.value[0].elements.email.value', '')
    const contactAssetType = _get(data, 'contact_person.value[0].elements.photo_or_video.value[0].type', '')
    this.photo = contactAssetType.includes('image') ? _get(data, 'contact_person.value[0].elements.photo_or_video.value[0]') : ''
    this.videoUrl = contactAssetType.includes('video') ? _get(data, 'contact_person.value[0].elements.photo_or_video.value[0].url') : ''
    this.position = _get(data, 'contact_person.value[0].elements.position.value', '')
    this.linkedIn = _get(data, 'linkedin.value', '')
    this.calendlyText = _get(data, 'calendly_text.value', '')
    this.calendlyUrl = _get(data, 'calendly_url.value', '')
    this.regionCodes = _get(data, 'region.value', []).map((region: { codename: string }) => region.codename).join()
  }
}

const contactSectionFragment = graphql`
query ContactSectionQuery {
  allKontentItemPage {
    nodes {
      elements {
        content {
          value {
            ... on kontent_item_contact_section {
              elements {
                ...kontent_item_contact_section_elementsFragment
              }
              preferred_language
              system {
                codename
              }
            }
          }
        }
      }
      system {
        codename
      }
    }
  }
}`

export const contactSectionElementsFragment = graphql`
  fragment kontent_item_contact_section_elementsFragment on kontent_item_contact_section_elements {
    section_header {
      value
    }
    linkedin {
      value
    }
    calendly_text {
      value
    }
    calendly_url {
      value
    }
    contact_person {
      value {
        ... on kontent_item_employee_element {
          elements {
            name {
              value
            }
            mobile {
              value
            }
            email {
              value
            }
            photo_or_video {
              value {
                url
                description
                height
                name
                size
                type
                width
              }
            }
            position {
              value
            }
          }
        }
      }
    }
    region {
      value {
        codename
      }
    }
  }
`

export const useContactSectionData = (language: string, pageCodename: string) => {
  const data = useStaticQuery(contactSectionFragment)
  const contactSectionData: KenticoContactSection[] = filterSectionsByLanguage(data.allKontentItemPage, pageCodename, language)
  return contactSectionData.map(data => new ContactSection(_get(data, 'elements', {})))
}